module.exports = __webpack_public_path__ + "static/media/doubleArrow-01.724b5cba.jpg";